import React from "react";
import { AppState } from "./Types";
import { Box, Divider, Grow, Typography } from "@mui/material";
import { alphabet } from "./Tile";
import { CircularProgressWithLabel } from "./Progress";
import { findPossibleMoves } from "./Functions";
import RadarOutlinedIcon from '@mui/icons-material/RadarOutlined';

function Log({
  appState,
  setAppState,
}: {
  appState: AppState;
  setAppState: React.Dispatch<React.SetStateAction<AppState>>;
}) {
  let possible = findPossibleMoves(appState);
  let possibleCoords: number[][];
  if (possible) {
    possibleCoords = possible?.map((move) => {
      return [
        move[0] + appState.knightPosition.row,
        move[1] + appState.knightPosition.col,
      ];
    });
  } else {
    possibleCoords = [];
  }

  let lastMoves = appState.pastMoves.slice(-3);

  return (
    <Grow
    in={true}
    style={{ transformOrigin: "0 0 0" }}
    {...(true ? { timeout: 1200 } : {})}
  >
    <div id="log" className="box surface">
      <div className="box-title"><RadarOutlinedIcon fontSize="small" sx={{marginRight: '4px'}} />Tour Monitor</div>
      <Box sx={{ width: "86%", paddingY: "1rem" }}>
        <div className="row tracking">
          <div
            style={{
              height: "72px",
              width: "72px",
              display: "flex",
              placeContent: "center",
            }}
          >
            <CircularProgressWithLabel
              value={
                (appState.pastMoves.length / appState.boardSize ** 2) * 100
              }
              size={"72px"}
              sx={{ marginRight: "1rem" }}
            />
          </div>
          <div
            className="col"
            style={{
              height: "72px",
            }}
          >
            <Typography variant="subtitle2">Last Moves</Typography>
            {lastMoves.map((move, index) => {
              return (
                <Typography
                  color={"#b8b8b8"}
                  key={index}
                  variant="caption"
                  fontSize={"0.7rem"}
                >
                  {"Knight to " + move.row + alphabet[move.col - 1]}
                </Typography>
              );
            })}
          </div>
          <div
            className="row row-wrap"
            style={{
              height: "72px",
            }}
          >
            <Typography variant="subtitle2">Possible</Typography>
            {possibleCoords.map((tile, index) => {
              return (
                <Typography
                  color={"#b8b8b8"}
                  key={index}
                  variant="caption"
                  fontSize={"0.7rem"}
                >
                  {tile[0] + alphabet[tile[1] - 1] + ""}
                </Typography>
              );
            })}
            {possibleCoords.length === 0 ? (
              <Typography
                color={"#b8b8b8"}
                variant="caption"
                fontSize={"0.7rem"}
              >
                None!
              </Typography>
            ) : (
              ""
            )}
          </div>
        </div>
        {/* <Divider sx={{ marginTop: "1.2rem" }} /> */}
      </Box>
    </div>
    </Grow>
  );
}

export default Log;
